// extracted by mini-css-extract-plugin
export var colorSquare = "_nn-0";
export var danger = "_nn-5";
export var lightPink = "_nn-8";
export var neutralBlue = "_nn-7";
export var neutralYellow = "_nn-6";
export var normal = "_nn-1";
export var primary = "_nn-2";
export var primaryLight = "_nn-3";
export var solidBlack = "_nn-g";
export var solidGreen = "_nn-b";
export var solidLightBlue = "_nn-d";
export var solidNavy = "_nn-c";
export var solidOrange = "_nn-f";
export var solidPink = "_nn-e";
export var solidRed = "_nn-9";
export var solidYellow = "_nn-a";
export var success = "_nn-4";